<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-row>
    <v-col cols="12" md="6">
      <weight-chart-card />
    </v-col>
    <v-col cols="12" md="6">
    <base-material-card
      icon="mdi-speedometer"
      color="primary"
      title="Weigh-ins"
      class="px-5 py-1"
      :loading="deletingWeight"
    >
        <v-data-table
          :headers="headers"
          :items="weighins"
          :items-per-page="5"
          mobile-breakpoint="400"
        >
          <template v-slot:item.l="{ item }">           
              <span>{{ isNaN(item.p - item.w) ? 0 : (Math.abs(item.p - item.w)).toFixed(2).replace(/[.,](00)|0$/, '') }} {{ profile.u }}</span>
              <v-icon v-if="item.p - item.w > 0" color="secondary">mdi-arrow-bottom-right</v-icon>
              <v-icon v-if="item.p - item.w < 0" color="primary">mdi-arrow-top-right</v-icon>
              <v-icon v-if="item.p - item.w == 0 || isNaN(item.p - item.w)" color="grey">mdi-arrow-right</v-icon>              
          </template>
          <template v-slot:item.w="{ item }">
            {{ (item.w).toFixed(1) }} {{ profile.u }}
          </template>
          <template v-slot:item.d="{ item }">
            {{ item.d | moment('DD MMM YY') }}
          </template>

          <template v-slot:item.actions="{ item }">
            <!-- <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon> -->
            <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
          </template>

        </v-data-table>
        <v-card-actions>
          <v-spacer />
          <v-btn type="submit" color="primary" @click="setWeighInModal(true)">Weigh In</v-btn>
          <v-spacer />
        </v-card-actions>
    </base-material-card>
    </v-col>
    </v-row>
    <!-- DIALOGS -->
    <v-dialog v-model="showConfirmDelete" max-width="300">
      <v-card>
        <v-card-title>
          <span>Are you sure?</span>
          <v-spacer />
          <v-icon aria-label="Close" @click="showConfirmDelete=false">mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="pb-6 pt-12 text-center">
          Would you like to delete your weigh-in for {{ selectedWeight.d | moment('DD MMMM YYYY') }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" text  @click="showConfirmDelete=false">
            No
          </v-btn>
          <v-btn  color="error" text @click="deleteWeightConfirmed()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- SNACKBARS -->
    <base-material-snackbar
      v-model="showSnackbar"
      :type="snackbartype"
      top
      center
    >
      <span v-text="snackbarmessage">
      </span>
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import weightChartCard from '@/views/dashboard/component/WeightChartCard'

  export default {
    components: {
      weightChartCard,
    },
    name: 'weight-diary',
    data () {
      return {
        selectedWeight: {d:'',w:''},
        showConfirmDelete: false,
        showSnackbar: false,
        snackbarmessage: '',
        snackbartype: 'success',
        headers: [
          {
            text: 'Date',
            align: 'start',
            value: 'd',
          },
          { 
            text: 'Weight', 
            value: 'w',
            align: 'end', },

          { 
            text: 'Progress', 
            value: 'l',
            align: 'center' 
            },
          { 
            text: '', 
            value: 'actions',
            align: 'end',
          },
        ],
      }
    },
    computed: {
      ...mapState('Diary', ['weightDiary', 'deletingWeight', 'deletingWeightError']),
      ...mapState('Profile', ['profile']),
      weighins() {
        const weights = Array.from(this.weightDiary);
        let prev = weights.slice;
        weights.forEach(item => {
          item.p = prev;
          prev = item.w
        })
        return weights.reverse();
      }
    },

    methods: {
      ...mapActions('Diary', ['deleteWeight']),
      ...mapMutations('Ui', ['setWeighInModal']),
      confirmDelete(weight){
        this.selectedWeight = weight;
        this.showConfirmDelete = true;
      },
      showSnackBar(barType, barMessage) {
        this.snackbarmessage = barMessage;
        this.snackbartype = barType;
        this.showSnackbar = true;
        setTimeout(() => {
          this.showSnackbar = false;
        }, 2000);
      },
      deleteWeightConfirmed() {
        this.showConfirmDelete = false;
        this.deleteWeight(this.selectedWeight)
        .then(() => {
          this.showSnackBar('success', 'Weigh-in deleted successfully')
        })
        .catch(() => {
          this.showSnackBar('error', 'There was an error deleting your weigh-in')
        });
      }
    },
    mounted: function() {
    }
  }
</script>
<style >
</style>